import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { filter } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { DictionaryService } from '../../services/dictionary.service';
import { WebsocketService } from '../../services/websocket.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form = new FormGroup({
    CardNumber: new FormControl('', [Validators.required]),
    ConvictedPassword: new FormControl('', [Validators.required]),
  });
  dateMask = [/[0-1-2-3]/, /[0-9]/, '.', /[0-1]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

  passwordVisible = false;
  passwordMask = new Array(140).fill(/[^А-яЁё]/);
  serverError: string = '';
  processing = false;

  get login() {
    return this.form.controls.CardNumber;
  }

  get password() {
    return this.form.controls.ConvictedPassword;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dictionaryService: DictionaryService,
    private webSocket: WebsocketService,
    @Inject(LOCALE_ID) public locale: string
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams?.logout) {

      this.authService.logout();
    }

    this.form.valueChanges.pipe(filter(() => !!this.serverError.length)).subscribe(item => {
      this.serverError = '';
    })
  }

  auth() {
    if (this.form.invalid) {
      this.password.setValue('');
      return;
    }
    this.processing = true;
    const form = this.form.getRawValue();

    this.authService.login(form).subscribe(userInfo => {
      this.router.navigate(['chat']);
      this.processing = false;

      if (this.authService.isAuthenticated()) {
        this.dictionaryService.init();
        // @ts-ignore
        this.authService.nameOrg = localStorage.getItem('orgName');
        this.authService.info().subscribe(x => {
          this.webSocket.init();
          this.webSocket.sendMessage({
            Event: "auth",
            Token: this.authService.token
          });
          this.webSocket.pingStart();
        });
      }
    }, error => {
      console.log('error', error);
      this.serverError = error.error.detail;
      this.processing = false;
    });

  }
}
